import React from 'react';
import PropTypes from 'prop-types';
import FormModal from "../../../components/common/modals/FormModal";
import graphql from "babel-plugin-relay/macro";
import {useFragment, useMutation} from "react-relay";
import {allIdentifierTypesDropdown, allIdentifierUseCodesDropdown} from "../../../relay/Fragments";
import * as yup from "yup";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {toast} from "react-toastify";
import HorizontalFormSelect from "../../../components/common/horizontal-form-inputs/HorizontalFormSelect";
import HorizontalFormInput from "../../../components/common/horizontal-form-inputs/HorizontalFormInput";
import HorizontalFormDate from "../../../components/common/horizontal-form-inputs/HorizontalFormDate";
import {bandedSchema, newBandDefaultValues} from "../../../helpers/bandedUtils";

const NewPractitionerIdentifierModal = ({showModal, onClose, practitionerId, identifierTypes, identifierUseCodes}) => {
    const mutation = graphql`
    mutation NewPractitionerIdentifierModalMutation($practitionerId: ID!, $identifierTypeId: ID!, $identifierUseCodeId: ID!,
        $value: String!, $effectiveFrom: DateOnly!, $effectiveTo: DateOnly! ) {
        practitioner {
            createIdentifier(input: {practitionerId: $practitionerId, identifierTypeId: $identifierTypeId, identifierUseCode: $identifierUseCodeId,
            value: $value, effectiveFrom: $effectiveFrom, effectiveTo: $effectiveTo}) {
                practitionerIdentifier {
                    id
                    practitioner {
                        identifiers {
                            ...PractitionerIdentifiers_Identifiers
                        }}}}}}`
    const idTypes = useFragment(allIdentifierTypesDropdown, identifierTypes).map((id) => {return {value: id.id, label:id.display}});
    const idUseCodes = useFragment(allIdentifierUseCodesDropdown, identifierUseCodes).map((id) => {return {value: id.id, label: id.display}});
    const [commitMutation, isInFlight] = useMutation(mutation);
    const defaultValues = {
        ...newBandDefaultValues,
        practitionerId: practitionerId,
        identifierTypeId: '',
        identifierUseCodeId: '',
        value: '',
    };
    const schema = bandedSchema.shape({
        identifierTypeId: yup.string().required("Identifier Type is required"),
        identifierUseCodeId: yup.string().required("Identifier Use Code is required"),
        value: yup.string().required("Value is required")
    });

    const methods = useForm({defaultValues: defaultValues, resolver: yupResolver(schema)});

    const handleSubmit = (data) => {
        commitMutation({variables: {...data}, onCompleted: (data) => {
                if(data.practitioner) {
                    toast.success("Identifier for Provider created")
                    methods.reset();
                    onClose();
                }
            }})
    }
    return (
        <FormModal showModal={showModal}
                    onClose={onClose}
                   title={"New Identifier"}
                   methods={methods}
                   isInFlight={isInFlight}
                   onSubmit={handleSubmit}
                   buttonText={"Create"}
                   inFlightButtonText={"Creating"}
        >
            <HorizontalFormSelect options={idTypes} controlId={"identifierTypeId"} label={"Identifier Type"} />
            <HorizontalFormSelect options={idUseCodes} controlId={"identifierUseCodeId"} label={"Identifier Use Code"} />
            <HorizontalFormInput controlId={"value"} label={"Value"} />
            <HorizontalFormDate controlId={"effectiveFrom"} label={"Effective From"} />
            <HorizontalFormDate controlId={"effectiveTo"} label={"Effective To"} />
        </FormModal>
    )
}
NewPractitionerIdentifierModal.propTypes = {
    showModal: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    practitionerId: PropTypes.string.isRequired,
    identifierTypes: PropTypes.array.isRequired,
    identifierUseCodes: PropTypes.array.isRequired
}
export default NewPractitionerIdentifierModal